<template>
  <div class="file-drag-drop">
    <form ref="fileForm" class="file-drag-drop__form">
      <div v-if="files.length" class="file-drag-drop__listing">
        <div
          v-for="(file, index) in files"
          :key="index"
          class="file-drag-drop__file"
        >
          <v-btn
            class="file-drag-drop__file-icon"
            tile
            fab
            dark
            x-small
            depressed
            color="blue-light"
          >
            <v-icon color="blue" x-small>mdi-file</v-icon>
          </v-btn>
          <span class="file-drag-drop__file-name">
            {{ file.name }}
          </span>
          <v-btn icon x-small color="red" class="ml-auto" @click="removeFile">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-else class="file-drag-drop__drop-zone">
        <label class="file-drag-drop__input-label" for="attachments">
          <span class="file-drag-drop__add-btn">
            <v-icon color="blue">mdi-upload</v-icon>
          </span>
          <div><span class="blue--text">Click to choose your</span> files or drag it here!</div>
          <input
            id="attachments"
            class="file-drag-drop__input"
            type="file"
            size="60"
            multiple="multiple"
            name="attachments"
            @change="inputFiles"
          >
        </label>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dragAndDropCapable: false,
      errors: [],
    };
  },

  computed: {
    files: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
        this.$refs.fileForm.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, false);
      });

      this.$refs.fileForm.addEventListener('drop', (e) => {
        this.addFiles(e);
      });
    }
  },

  beforeDestroy() {
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
      this.$refs.fileForm.removeEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  },

  methods: {
    determineDragAndDropCapable() {
      const div = document.createElement('div');

      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    },

    inputFiles(e) {
      this.addFiles(e);
    },

    addFiles(e) {
      const fileList = e.target.files || e.dataTransfer.files;
      const errors = [];

      const megabyteInBytes = 1048576;
      const limitInMegabytes = 10;

      for (let i = 0; i < fileList.length; i += 1) {
        if (fileList[i].size / megabyteInBytes < limitInMegabytes) {
          this.files.push(fileList[i]);
        } else {
          errors.push(`File ${fileList[i].name} is to big`);
        }
      }

      if (errors.length) this.$emit('error', errors);
    },

    removeFile(index) {
      this.files.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-drag-drop {
  background: #FCFCFC 0% 0% no-repeat padding-box;
  border: 1px dashed #E2E6EA;
  border-radius: 4px;

  &__form {
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }

  &__drop-zone {
    font-weight: 500;
    text-align: center;
  }

  &__input-label {
    cursor: pointer;
  }

  &__add-btn {
    border-radius: 8px;
    margin-bottom: 8px;
    height: 32px;
    width: 32px;
    line-height: 32px;
    text-align: center;
    background: $color--blue-light;
    display: inline-block;
  }

  &__file {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    color: $main--text;
    margin-bottom: 8px;
    word-break: break-word;
  }

  &__input {
    display: none;
  }

  &__listing {
    width: 100%;
  }

  &__file-icon {
    border-radius: 6px;
    margin-right: 16px;
    height: 24px;
    width: 24px;
    cursor: default;
  }
}
</style>
